import { render, staticRenderFns } from "./ManuallyCreateLabAutomate.vue?vue&type=template&id=2d6769d2&scoped=true"
import script from "./ManuallyCreateLabAutomate.vue?vue&type=script&lang=js"
export * from "./ManuallyCreateLabAutomate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6769d2",
  null
  
)

export default component.exports